import ActionType from './actionTypes'

export function resetState() {
  return {
    type: ActionType.RESET_STATE
  }
}



// WEBPACK FOOTER //
// ./client/modules/app/actions.js